import PropTypes from 'prop-types';
import { classes } from '@/helpers/styling';
import Text, { FONT_SIZE_040 } from '@/components/component-library/Text';

const Selector = ({
  id,
  value,
  onClick,
  label,
  disabled,
  className
}) => {
  const handleClick = () => {
    onClick({
      id,
      value
    });
  };

  const selector = (
    <div
      className={ classes('selector', { '--is-disabled': disabled }, className) }
      onClick={ disabled ? undefined : handleClick }
    >
      <Text
        bold
        className='value' useHeaderFont
      >
        { value }
      </Text>
      <div className='arrow' />
    </div>
  );

  return label ? (
    <div className='selector-wrapper'>
      <Text
        className='label'
        size={ FONT_SIZE_040 }
      >
        { label }
      </Text>
      { selector }
    </div>
  ) : selector;
};

Selector.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

Selector.defaultProps = {
  id: null,
  label: null,
  disabled: false,
  className: ''
};

export default Selector;